import React from "react";
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { medecinComp, medecinuom } from '../utils/datalist';
import { Modal, Button, Form } from "react-bootstrap";

const MonthlyIssueRegisterCom=()=>{

    const [itemData,setItemData]=useState([]);
    const [noResults, setNoResults] = useState(false);
    const [aYear,setAYear]=useState('');
    

    const handleSubmit=async(e)=>{
    e.preventDefault();

    if (!aYear) {
        alert('Dates required.');
        return;
    }   

    try {
      const res = await axios.get(configData.SERVER_URL+`/monthlyIssueRegister/${aYear}/${localStorage.getItem('branchID')}`);
      setItemData(res.data);      

      if (res.data.length === 0) {
        setNoResults(true);
      } else {
        setNoResults(false);
      }
    } catch (error) {
      console.error('Search error:', error);
    }   
    }

    return(
        <>             
                <div className="row">
                    <div className="card well bg-info "> 
                    <div className="card-header">Monthly Issue Register</div>
                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        <div className="col-lg-3">
                                            <label>Financial Year</label>
                                            <input type="number" className="form-control" name="aYear" id="aYear" value={aYear}
                                                onChange={(e) => setAYear(e.target.value)}></input>
                                        </div>

                        <div className="col-lg-2">
                                            <br></br>
                                            <button type="button" class="btn btn-info">
                                                <span class="glyphicon glyphicon-search" onClick={(e)=>{handleSubmit(e)}}><Icon.Search/></span>
                                            </button>
                                        </div>
                    </div>

                    {noResults && <p class="text-center" >No results found.</p>}

                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        <div className="table-responsive-sm table-responsive-md table-responsive-lg table-responsive-sl table-responsive-xxl">
                        <table class="table table-success table-hover table-bordered">
                            <thead>
                                <tr>
                                <th>#</th>
                                <th>Item Name</th>
                                <th>Ope. Stock</th>
                                <th>July</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Total Issue</th>
                                <th>Clo. Bal.</th>
                                <th>Unit</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                    itemData && itemData.length>0 && itemData.map((data,i)=>
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td align="left">{data.itemName}</td>
                                        <td align="left">{data.openingStock}</td>
                                        <td align="left">{data.Jul}</td>
                                        <td align="left">{data.Aug}</td>
                                        <td align="left">{data.Sep}</td>
                                        <td align="left">{data.Oct}</td>
                                        <td align="left">{data.Nov}</td>
                                        <td align="left">{data.Nov}</td>
                                        <td align="left">{data.Jan}</td>
                                        <td align="left">{data.Feb}</td>
                                        <td align="left">{data.Mar}</td>
                                        <td align="left">{data.Apr}</td>
                                        <td align="left">{data.May}</td>
                                        <td align="left">{data.Jun}</td>
                                        <td align="left">{data.TotalIssue}</td>
                                        <td align="left">{data.closingBalance}</td>
                                        <td align="left">{data.uom}</td>
                                    </tr>
                                    )} 
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
        </>
    )
}

export default MonthlyIssueRegisterCom;